import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TurnVoiceNotesIntoContent = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 24 24`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M10.8281 3.60909C10.8281 2.79129 11.491 2.12834 12.3088 2.12834C13.1266 2.12834 13.7896 2.79129 13.7896 3.60909V20.3908C13.7896 21.2086 13.1266 21.8716 12.3088 21.8716C11.491 21.8716 10.8281 21.2086 10.8281 20.3908V3.60909Z"
          fill="url(#paint0_linear_4895_103464)"
        />
        <path
          d="M14.9002 8.2364C14.9002 7.41861 15.5631 6.75566 16.3809 6.75566C17.1987 6.75566 17.8617 7.41861 17.8617 8.2364V15.7628C17.8617 16.5806 17.1987 17.2435 16.3809 17.2435C15.5631 17.2435 14.9002 16.5806 14.9002 15.7628V8.2364Z"
          fill="url(#paint1_linear_4895_103464)"
        />
        <path
          d="M6.75598 8.2364C6.75598 7.41861 7.41893 6.75566 8.23672 6.75566C9.05452 6.75566 9.71747 7.41861 9.71747 8.2364V15.7628C9.71747 16.5806 9.05452 17.2435 8.23672 17.2435C7.41893 17.2435 6.75598 16.5806 6.75598 15.7628V8.2364Z"
          fill="url(#paint2_linear_4895_103464)"
        />
        <path
          d="M2.68387 11.9768C2.68387 11.159 3.34682 10.4961 4.16461 10.4961C4.9824 10.4961 5.64535 11.159 5.64535 11.9768V12.0233C5.64535 12.8411 4.9824 13.5041 4.16461 13.5041C3.34682 13.5041 2.68387 12.8411 2.68387 12.0233V11.9768Z"
          fill="url(#paint3_linear_4895_103464)"
        />
        <path
          d="M18.9723 11.9768C18.9723 11.159 19.6352 10.4961 20.453 10.4961C21.2708 10.4961 21.9338 11.159 21.9338 11.9768V12.0233C21.9338 12.8411 21.2708 13.5041 20.453 13.5041C19.6352 13.5041 18.9723 12.8411 18.9723 12.0233V11.9768Z"
          fill="url(#paint4_linear_4895_103464)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_4895_103464"
            x1="12.3088"
            y1="2.12834"
            x2="12.3088"
            y2="21.8716"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EC1E28" />
            <stop offset="1" stopColor="#960007" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_4895_103464"
            x1="16.3809"
            y1="6.75566"
            x2="16.3809"
            y2="17.2435"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EC1E28" />
            <stop offset="1" stopColor="#960007" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_4895_103464"
            x1="8.23672"
            y1="6.75566"
            x2="8.23672"
            y2="17.2435"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EC1E28" />
            <stop offset="1" stopColor="#960007" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_4895_103464"
            x1="4.16461"
            y1="10.4961"
            x2="4.16461"
            y2="13.5041"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EC1E28" />
            <stop offset="1" stopColor="#960007" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_4895_103464"
            x1="20.453"
            y1="10.4961"
            x2="20.453"
            y2="13.5041"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#EC1E28" />
            <stop offset="1" stopColor="#960007" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default TurnVoiceNotesIntoContent
